import { render, staticRenderFns } from "./adicao.vue?vue&type=template&id=7d6da9b2"
import script from "./adicao.ts?vue&type=script&lang=js&external"
export * from "./adicao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6da9b2')) {
      api.createRecord('7d6da9b2', component.options)
    } else {
      api.reload('7d6da9b2', component.options)
    }
    module.hot.accept("./adicao.vue?vue&type=template&id=7d6da9b2", function () {
      api.rerender('7d6da9b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/adicao.vue"
export default component.exports